import React from "react"
import { useBlocks } from "../../hooks/use-blocks"
import { parseISO, format } from "date-fns"
import { filterEvents as filteredEvents } from "./events"
import { Block } from "../shared/block"

export function BandsInTown({ id }) {
  const { properties } = useBlocks(id)
  const events = filteredEvents(
    properties.events,
    properties.startDate,
    properties.endDate
  )

  if (!properties.name) {
    return (
      <Block id={id}>
        <div style={{ height: "200px" }} data-testid={id}>
          <div className="relative" style={{ height: "200px" }}>
            <div className="border-2 flex absolute justify-center items-center inset-0 w-full text-gray-500 border-dashed  hover:text-gray-600 transition duration-200 border-gray-500 hover:border-gray-600 mt-8 mb-8 text-xl">
              Enter a band name to list upcoming events.
            </div>
          </div>
        </div>
      </Block>
    )
  }

  if (!events?.length) {
    return (
      <Block id={id}>
        <div style={{ height: "200px" }} data-testid={id}>
          <div className="relative" style={{ height: "200px" }}>
            <div className="border-2 flex absolute justify-center items-center inset-0 w-full text-gray-500 border-dashed  hover:text-gray-600 transition duration-200 border-gray-500 hover:border-gray-600 mt-8 mb-8 text-xl">
              There are no events for this band.
            </div>
          </div>
        </div>
      </Block>
    )
  }

  return (
    <Block
      id={id}
      style={{ color: properties.textColor }}
      className="ck-bandsintown-block"
    >
      <div data-block-id={id}>
        {events &&
          events.map((event, index) => {
            const time = new Date(event.event_timestamp)
            return (
              <div
                data-testid={id}
                key={`${event.name}-${index}`}
                className="justify-between"
                style={{
                  display: "flex",
                  paddingTop: "2px",
                  paddingBottom: "6px",
                  marginBottom: "8px",
                  borderBottom: ".75px solid rgba(209, 213, 219)"
                }}
              >
                <div
                  style={{
                    paddingBottom: "0px",
                    width: "42px",
                    flexShrink: 0
                  }}
                >
                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "12px",
                      padding: "0px",
                      marginLeft: "2px"
                    }}
                  >
                    {format(
                      parseISO(event.event_timestamp),
                      "MMM"
                    ).toUpperCase()}
                  </div>
                  <div
                    style={{
                      paddingLeft: "1px",
                      fontWeight: "600",
                      fontSize: "22px"
                    }}
                  >
                    {format(parseISO(event.event_timestamp), "dd")}
                  </div>
                </div>
                <div className="flex-grow">
                  <div className="" style={{ fontSize: "18px", padding: 0 }}>
                    {event.location === "Live Stream"
                      ? event.location
                      : event.name.length > 0
                      ? event.name
                      : properties.name}
                  </div>
                  {event.location === "Live Stream" ? (
                    <div
                      style={{
                        fontSize: "12px",
                        paddingTop: "2px",
                        paddingBottom: "0px"
                      }}
                    >
                      {time.toLocaleTimeString([], {
                        timeZoneName: "short",
                        hour12: "true",
                        hour: "numeric",
                        minute: "2-digit"
                      })}
                    </div>
                  ) : (
                    <div
                      style={{
                        fontSize: "12px",
                        paddingTop: "2px",
                        paddingBottom: "0px"
                      }}
                    >
                      {event.location}
                    </div>
                  )}
                </div>
                {!event.offer_url ? null : (
                  <div
                    style={{ width: "150px" }}
                    className="flex-row-reverse flex items-center"
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={event.offer_url}
                      style={{
                        display: "block",
                        textDecoration: "none",
                        color: "inherit",
                        marginLeft: "auto",
                        padding: "5px 24px",
                        borderRadius: "4px",
                        border: ".75px solid rgba(209, 213, 219)",
                        background: "transparent",
                        height: "35px"
                      }}
                    >
                      {event.offer_type}
                    </a>
                  </div>
                )}
              </div>
            )
          })}
      </div>
    </Block>
  )
}
